import React, { useEffect, useRef } from 'react';
import './AIReimagine.css';
import {Link} from 'react-router-dom'   
const cards = [
  {
    id: 1,
    title: 'FINTECH',
    desc: 'Craft tailored financial applications for digital transformation with us, including web and mobile trading platforms, retail banking, investment solutions, and stock exchange apps.',
    bg: '/images/fintech.webp',
  },
  {
    id: 2,
    title: 'PRODUCTIZATION',
    desc: 'Three men working and chatting on laptops with blue backgroundTransform your innovative ideas into market-ready, scalable offerings. From conceptualization to streamlined production, we guide you through every step of the productization journey.',
    bg: '/images/healthcare.webp',
  },
  {
    id: 3,
    title: 'TECHNOLOGY',
    desc: 'Whether its developing SaaS platforms or optimizing customer satisfaction, create tech solutions that not only set you apart but are also pivotal for your digital transformation journey.',
    bg: '/images/technology.avif',
  },
];

const ReimagineSection = () => {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    refs.current.forEach(ref => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="reimagine-section">
      <div className="container">
      <div className="reimagine-header">
        <h2 className="fade-left" ref={el => refs.current[0] = el}>
          WE HELP <span className="blue">REIMAGINE INDUSTRIES</span>
        </h2>
        <p className="fade-right" ref={el => refs.current[1] = el}>
          Explore how we partner with businesses across domains to create next-gen digital experiences that lead change.
        </p>
      </div>

      <div className="reimagine-cards">
        {cards.map((card, i) => (
          <div
            className="reimagine-card25 fade-up"
            key={card.id}
            ref={el => refs.current[i + 2] = el}
            style={{ backgroundImage: `url(${card.bg})` }}
          >
            <div className="card-overlay">
              <h3 className="card-title">{card.title}</h3>
              <div className="card-hover-content">
                <p>{card.desc}</p>
                <span className="explore-arrow">→ EXPLORE</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="reimagine-btn">
        <Link to="/indutries">
        <button>SEE ALL INDUSTRIES</button>
        </Link>
      </div>
      </div>
    </section>
  );
};

export default ReimagineSection;
